


































































import { Component, Vue, Watch } from "vue-property-decorator";
import { EntitiesService } from "@/services/api/entities.service";
import { Getter } from "vuex-class";
import { LanguageDto, EntityDto } from "@/server/app.dtos";
import { GetEntityDtoQuery } from "@/server/app.queries";
import { ISideMenuItem } from "@/models/menus/abstract/isidemenu";
import ConfigsService from "@/services/api/configs.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";

@Component
export default class EntityDetailSharedPage extends Vue {
  entitiesService: EntitiesService = new EntitiesService();
  configsService: ConfigsService = new ConfigsService();
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  entity: EntityDto | null = null;
  menus: ISideMenuItem[] = [
    {
      icon: "las la-cog",
      title: "Dashboard",
      url: "dashboard"
    },
    {
      icon: "las la-cog",
      title: "Utilizadores",
      url: "users"
    },
    {
      icon: "las la-cog",
      title: "Documentos",
      url: "documents"
    }
  ];
  actionMenu: boolean = false;
  isLoading: boolean = false;

  get currentPath(): string {
    return this.$route.path;
  }

  @Watch("$route")
  onRouteChange() {
    this.Load();
  }

  async created() {
    await this.Load();
  }

  async Load() {
    const query = new GetEntityDtoQuery();
    query.idEntity = parseInt(this.$route.params.id);
    // query.includes = new GetEntitiesDtosIncludeOptions();
    await this.entitiesService
      .GetSingle(query)
      .then((result: EntityDto) => {
        this.entity = result;
      })
      .catch(() => (this.entity = null));
  }

  async deleteEntity() {
    if (this.isLoading) {
      return;
    }
    if (this.entity) {
      const redirect = "/entities/";
      await this.entitiesService
        .DeleteById(this.entity.idEntity || 0)
        .catch((error: any) => NotificationServiceBus.showError(error))
        .then(() => this.$router.push(redirect));
    }
  }
}
